import { Injectable } from '@angular/core';
import * as moment from 'moment';

@Injectable({
  providedIn: 'root'
})
export class DatetimeService {

  constructor() { }

  public getDatumStr(datum: number): string {
    let d = moment(datum.toString(), 'YYYYMMDD').format('DD.MM.YYYY');
    return d.toString();
  }
}
